import * as React from 'react';
import { JsonObject } from '@bb/domain/dist/types';
import { User } from '@bb/users';
import { formatPhoneNumber } from 'utils';
import { ListingDoc, OrgDoc } from '@bb/domain/dist/schemas';

type OfferDisabledRegistrationProps = {
  listing: JsonObject<
    Omit<ListingDoc, 'reps' | 'org'> & {
      reps: User[];
      org: Pick<OrgDoc, 'addresses' | 'mls_name'>;
    }
  >;
};

const OfferDisabledRegistration: React.FunctionComponent<
  OfferDisabledRegistrationProps
> = ({ listing }) => {
  const { phone, name } =
    listing.org.addresses[listing.location as number][
      listing.address as unknown as number
    ];
  const [rep] = listing.reps;

  const listingDetails = {
    agentName: `${rep.firstName} ${rep.lastName}`,
    orgName: name || listing.org.mls_name,
    orgPhone: phone || listing.org.addresses[0][0].phone,
    mobile: rep.phone,
    email: rep.email,
    releaseCell: rep.frontEndInstructions.releaseCell,
  };

  return (
    <>
      <h4>
        Online Offer registration has been disabled for this property.
        <br />
        To register an offer, please call the Listing Brokerage.
      </h4>
      <br />
      <label>Contact Information:</label>
      <p>{listingDetails.agentName}</p>
      <p>{listingDetails.orgName}</p>
      <p>Office Phone: {formatPhoneNumber(listingDetails.orgPhone)}</p>
      {listingDetails.releaseCell && (
        <p>
          Agent Mobile:{' '}
          {listingDetails.mobile && formatPhoneNumber(listingDetails.mobile)}
        </p>
      )}
      <p>
        Agent Email:{' '}
        <a href={`mailto:${listingDetails.email}`}>{listingDetails.email}</a>
      </p>
    </>
  );
};

export default OfferDisabledRegistration;
